var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fragment fragment-html",class:`fragment-html--${_vm.content.type}`,domProps:{"innerHTML":_vm._s(_vm.doFollowContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }